export default __webpack_public_path__ + "static/media/cloudy.7ee697ea.jpg";